import { z } from 'zod/v4';
import { Currency } from '../../index.js';
import { PerformedBySchema } from '../../performed-by/index.js';
export const CreateBillingVoucherSchema = z.object({
    currency: z.enum(Currency),
    amount: z.number(),
    date: z.string(),
    voucherTypeId: z.string(),
    caseId: z.uuid(),
    billingVoucherId: z.uuid().nullish(),
    createdAt: z.string().nullish(),
    details: z.any().optional(),
    text: z.string().nullish(),
    referenceId: z.string().nullish(),
    createdBy: PerformedBySchema.nullish(),
});
export const billingVoucherSum = (billingVouchers) => billingVouchers.reduce((acc, billingVoucher) => billingVoucher.amount + acc, 0);
//# sourceMappingURL=index.js.map